import { render, staticRenderFns } from "./CouponQrcode.vue?vue&type=template&id=5b2db56a&scoped=true"
import script from "./CouponQrcode.vue?vue&type=script&lang=js"
export * from "./CouponQrcode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2db56a",
  null
  
)

export default component.exports